import Form     from 'scripts/poppet/form';
import template from 'templates/supportSearchForm.jst.html';

/**
 * defa.views.SupportSearchForm
 * A view for the Technical Support search.
 * @version 1.2.0
 */

const selectors = {
	inputSearch: '[data-input=search-search]',
};

const SupportSearchForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: 'support-search',
	noBusy   : true,
	
	ui: {
		input: selectors.inputSearch,
	},
	
	events: {
		'keypress @ui.input': 'onKeypressInput',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Submits the form, if there is content in it.
	 * @void
	 */
	submit: function () {
		
		let search = this.ui.input.val().trim();
		
		if ( search ) {
			this.trigger( 'search', search );
		}
	},
	
} );

export default SupportSearchForm;